import api from "!../../../../../../../projects/fat-admin/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../../projects/fat-admin/node_modules/css-loader/dist/cjs.js??clonedRuleSet-24.use[1]!../../../../../../../projects/fat-admin/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../projects/fat-admin/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-24.use[2]!../../../../../../../projects/fat-admin/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-24.use[3]!../../../../../../../projects/fat-admin/node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=0&id=746595d5&prod&lang=scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};